import Icon from './Icon';

export default function FaqList({ items }) {
  return (
    <div className="faq-list">
      {items.map((item) => (
        <details key={item.q} className="faq">
          <summary>
            <span>{item.q}</span>
            <Icon name="chevron" size={20} />
          </summary>
          <p>{item.a}</p>
        </details>
      ))}
    </div>
  );
}
